// @flow

export type TripSummary = {
  invoiceNumber: string,
  checkinDateTime: ?Date,
  checkoutDateTime: ?Date,
  description: string,
  amount: number
}

const buildTripSummary = (): TripSummary => {
  return {
    invoiceNumber: '',
    checkinDateTime: null,
    checkoutDateTime: null,
    description: '',
    amount: 0.0
  }
}

export {
  buildTripSummary
}



// WEBPACK FOOTER //
// ./src/types/trip-summary.js